import { SVGProps } from 'react';

const InrToggleDeactiveIcon = ({ width = 8, height = 10 }: SVGProps<SVGAElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-palette="InrToggleDeactiveIcon">
    <path
      d="M3.41828 10L0.898281 5.604V4.568H1.73828C2.07428 4.568 2.36828 4.52133 2.62028 4.428C2.88161 4.32533 3.09628 4.18067 3.26428 3.994C3.44161 3.80733 3.56295 3.58333 3.62828 3.322H0.898281V2.286H3.61428C3.55828 2.04333 3.46028 1.82867 3.32028 1.642C3.18961 1.45533 3.01228 1.31067 2.78828 1.208C2.57361 1.096 2.31228 1.04 2.00428 1.04H0.898281V0.00399935H7.21228V1.04H5.01428C5.17295 1.21733 5.30361 1.40867 5.40628 1.614C5.51828 1.81933 5.59295 2.04333 5.63028 2.286H7.21228V3.322H5.65828C5.56495 4.01267 5.29895 4.554 4.86028 4.946C4.42161 5.32867 3.85695 5.59 3.16628 5.73L5.91028 10H3.41828Z"
      fill="#5A606B"
    />
  </svg>
);
export default InrToggleDeactiveIcon;
